@if (error) {
    <small class="color-status-red4">
        An error occurred while loading the documents, please try in some time.
    </small>
} @else {
    @if (resultCount && totalDiscrepancyCount) {
        <div
            class="mt-1 mb-1 color-gray18"
            [attr.data-qa]="dataQa.documentViewResultCount">
            <span class="text-s">
                @if (selectedDiscrepancyCount) {
                    <span class="text-semi">
                        {{ selectedDiscrepancyCount }}/</span
                    >{{ totalDiscrepancyCount }} Discrepancies Selected
                } @else {
                    {{ resultCount }} Documents •
                    {{ totalDiscrepancyCount }} Discrepancies
                }
            </span>
        </div>
    }
    <app-table
        noRowsText="No workflow documents to show."
        [attr.data-qa]="dataQa.documentViewTable"
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
        [masterDetail]="true"
        [suppressMenu]="true"
        [detailCellRendererParams]="detailCellRendererParams"
        [totalItems]="resultCount"
        (gridReady)="onGridReady($event)">
    </app-table>
}
